var app = angular.module('leonardo');

var TemplateListFilters = function (
  $scope,
  TemplateService,
  CategoryCacheRestService,
  SubcategoryCacheRestService,
  SectorRestService,
  $controller,
  $state,
  ClientInstanceService,
  PermissionService,
) {
  
$controller('FiltersBaseController', { $scope: $scope });

  const clientInstanceOptions = ClientInstanceService.getlist({ essential: true }).then(function (response) {
    return response.map(function (clientInstance) {
      return {
        id: clientInstance.id,
        name: `${clientInstance.name} (id: ${clientInstance.id})`
      };
    });
  });

$scope.categories = [];

CategoryCacheRestService.getCategories().then(function(response) {
  if (response && response.length > 0) {
    $scope.categories = response.map(function(category) {
      return { id: category.id, name: category.name };
    });
  } else {
    console.warn('No categories found or invalid response');
    $scope.categories = []; 
  }
}, function(error) {
  console.error('Failed to fetch categories:', error);
  $scope.categories = []; 
});


$scope.$watch('categories', function(newValue, oldValue) {
  
  if (newValue.length > 0) {
    const categoryFilter = $scope.filters_options.find(option => option.elements.some(el => el.id === 'category'));
    if (categoryFilter) {
      const categoryElement = categoryFilter.elements.find(el => el.id === 'category');
      if (categoryElement) {
        categoryElement.options = newValue;
      }
    }
  }
}, true); 


$scope.subCategories = [];

SubcategoryCacheRestService.getSubCategories().then(function(response) {
  if (response && response.length > 0) {

    $scope.subCategories = response.map(function(category) {
      return { id: category.id, name: category.name }; 
    });
  } else {
    console.warn('No categories found or invalid response');
    $scope.subCategories = []; 
  }  
}, function(error) {
  console.error('Failed to fetch categories:', error);
  $scope.subCategories = []; 
});


$scope.$watch('subCategories', function(newValue, oldValue) {
  
  if (newValue.length > 0) {
    const subCategoryFilter = $scope.filters_options.find(option => option.elements.some(el => el.id === 'subcategory'));
    if (subCategoryFilter) {
      const subCategoryElement = subCategoryFilter.elements.find(el => el.id === 'subcategory');
      if (subCategoryElement) {
        subCategoryElement.options = newValue;
      }
    }
  }
}, true); 

  $scope.templateTypes = [];

  angular.forEach(TemplateService.TYPE_OPTIONS, function (type) {
    if (type.id !== TemplateService.TYPE_SYSTEM_WORKFLOW && type.id !== TemplateService.TYPE_ACCOUNT_WORKFLOW) {
      $scope.templateTypes.push(type);
    }
  });

  $scope.templateStatus = [
    { id: TemplateService.STATUS_PUBLISHED, name: 'Published' },
    { id: TemplateService.STATUS_UNPUBLISHED, name: 'Unpublished' }
  ];

  $scope.propertyTypes = [
    { id: 'residential', name: 'Residential' },
    { id: 'corporate', name: 'Corporate' },
    { id: 'commercial', name: 'Commercial' },
    { id: 'hoa', name: 'HOA' },
    { id: 'single-family ', name: 'Single Family' }
  ];

  var filters = $scope.filterService.hasFilter('filters') ? $scope.filterService.getFilter('filters') : [];

  if (!angular.isArray(filters)) {
    filters = filters.split(',');
  }

  if (!$scope.filterService.hasFilter('account_reports') && $scope.authDataService.isNotStaff()) {
    $scope.filterService.setFilter('account_reports', $scope.filterService.accounts.length > 0 ? $scope.filterService.accounts[0].id : null);
    if (!_.contains(filters, 'account_reports')) {
      filters.unshift('account_reports');
    }
  }

  if (!$scope.filterService.hasFilter('status') && $state.current.name === 'templates.list') {
    $scope.filterService.setFilter('status', TemplateService.STATUS_PUBLISHED, true);
    if (!_.contains(filters, 'status')) {
      filters.push('status');
    }
  }

  $scope.filterService.setFilter('filters', filters, true);
  $scope.filterService.showFilters(['property_reports', 'status', 'type', 'category', 'recurrence_type', 'name__icontains']);


  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'client_instances',
          name: 'Client Instance',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Client Instances',
          condition: $scope.authDataService.isAdmin(),
          options: clientInstanceOptions,
          conflicts: ['account_reports', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1 && $scope.authDataService.isNotStaff(),
          options: $scope.filterService.accounts,
          conflicts: ['client_instances', 'property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1 && $scope.authDataService.isNotStaff(),
          options: $scope.filterService.managers,
          conflicts: ['client_instances', 'property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account && $scope.authDataService.isNotStaff(),
          options: $scope.filterService.groups,
          conflicts: ['client_instances', 'property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          required: false,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account && $scope.authDataService.isNotStaff(),
          options: $scope.filterService.portfolios,
          conflicts: ['client_instances', 'property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          required: false,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account && $scope.authDataService.isNotStaff(),
          options: $scope.filterService.properties,
          conflicts: ['client_instances', 'portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      group: 'template_filters',
      name: 'By Template Have',
      elements: [
        {
          id: 'sector',
          name: 'Sector',
          label: null,
          inline: false,
          type: 'options',
          multiple: false,
          placeholder: 'Select sector',
          condition: $scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin(),
          service: SectorRestService,
          conflicts: ['category']
        },
        {
          id: 'status',
          name: 'Template Status',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Status',
          condition: true,
          options: $scope.templateStatus,
          conflicts: []
        },
        {
          id: 'type',
          name: 'Template Type',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Types',
          condition: $scope.authDataService.isNotStaff(),
          options: $scope.templateTypes,
          conflicts: []
        },
        {
          id: 'category',
          name: 'Category',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Categories',
          condition: true,
          options:$scope.categories,
          conflicts: ['sector']
        },
        {
          id: 'subcategory',
          name: 'Subcategory',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Subcategories',
          condition: true,
          options:$scope.subCategories,
          conflicts: ['sector']
        },
        {
          id: 'recurrence_type',
          name: 'Recurrence',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Recurrences',
          condition: true,
          options: TemplateService.RECURRENCE_OPTIONS,
          conflicts: []
        },
        {
          id: 'property_type',
          name: 'Property Type',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Property Types',
          condition: true,
          options: $scope.propertyTypes,
          conflicts: []
        },
        {
          id: 'name__icontains',
          name: 'Template Name',
          label: null,
          inline: false,
          type: 'text',
          placeholder: 'Template Name',
          condition: true,
          conflicts: [],
          onSubmit: $scope.filter
        },
        {
          id: 'levels',
          name: 'Address',
          label: null,
          inline: false,
          type: 'levels',
          condition: true,
          conflicts: []
        },
        {
          id: 'group_subcategory',
          name: 'Group by Subcategory',
          label: null,
          inline: false,
          type: 'checkbox',
          condition: true,
          conflicts: []
        },
        {
          id: 'role',
          name: 'Role',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          options: $scope.authDataService.getRolesValid(),
          condition: PermissionService.isOwner(),
          conflicts: []
        }
      ]
    }
  ];

  $scope.$on('filter-service:filter-changed', function (event, key, value) {
    if (key === 'filters' && ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin())) {
      var changed_filters = value ? value : [];

      if (!angular.isArray(changed_filters)) {
        changed_filters = changed_filters.split(',');
      }
      if (_.contains(changed_filters, 'account_reports') && !$scope.filterService.hasFilter('account_reports')) {
        $scope.filterService.setFilter('account_reports', $scope.filterService.accounts.length > 0 ? $scope.filterService.accounts[0].id : null);
      }
      if (_.contains(changed_filters, 'managed_by_reports') && !$scope.filterService.hasFilter('managed_by_reports')) {
        $scope.filterService.setFilter('managed_by_reports', $scope.filterService.managers.length > 0 ? $scope.filterService.managers[0].id : null);
      }
      if (_.contains(changed_filters, 'group_reports') && !$scope.filterService.hasFilter('group_reports')) {
        $scope.filterService.setFilter('group_reports', $scope.filterService.groups.length > 0 ? $scope.filterService.groups[0].id : null);
      }
      if (_.contains(changed_filters, 'portfolio_reports') && !$scope.filterService.hasFilter('portfolio_reports')) {
        $scope.filterService.setFilter('portfolio_reports', $scope.filterService.portfolios.length > 0 ? $scope.filterService.portfolios[0].id : null);
      }
      if (_.contains(changed_filters, 'property_reports') && !$scope.filterService.hasFilter('property_reports')) {
        $scope.filterService.setFilter('property_reports', $scope.filterService.properties.length > 0 ? $scope.filterService.properties[0].id : null);
      }
    }
  });
};

app.controller('TemplateListFilters', [
  '$scope',
  'TemplateService',
  'CategoryCacheRestService',
  'SubcategoryCacheRestService',
  'SectorRestService',
  '$controller',
  '$state',
  'ClientInstanceService',
  'PermissionService',
  TemplateListFilters
]);
